import Money from "js-money";
import currencies from "iso-currencies";
import pluralizer from "pluralize";
import humanizeString from "string-humanize";
import accounting from "accounting";

const urlParser = document.createElement("a");

export function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

export function count(arr) {
  return arr.length;
}

export function pluralize(count, label) {
  return pluralizer(label, count);
}

export function money(amount, currencyCode) {
  let display = "";
  if (!amount) {
    amount = 0;
  }
  const money = Money.fromInteger(amount, currencyCode.toUpperCase());
  const currency = money.getCurrency();
  display += Money[currency].symbol;
  display += money.toString();
  return display;
}

export function currencySymbol(currencyCode) {
  let display = "";
  const currency = currencies.information(currencyCode.toUpperCase());
  if (currency && currency.symbol) {
    display = currency.symbol;
  }
  return display;
}

export function humanize(str) {
  let result = humanizeString(str);

  // handle some special cases
  if (str === "bluePad5000") {
    result = "BluePad 5000";
  } else if (str === "bluePad50") {
    result = "BluePad 50";
  } else if (str === "bluePad55") {
    result = "BluePad 55";
  } else if (str === "bluePad55_4g") {
    result = "BluePad 55 (4G)";
  } else if (str === "softpos") {
    result = "SoftPOS";
  } else if (str === "ecommerce") {
    result = "E-Commerce";
  } else if (str === "pos") {
    result = "POS";
  }

  return result;
}

export function percentageChange(number, appendSymbol) {
  let result;

  if (!number) {
    return 0;
  } else {
    result = (number * 100).toFixed(2);
  }

  if (result > 0) {
    result = `+${result}`;
  }

  if (appendSymbol) {
    result = `${result}%`;
  }

  return result;
}

export function number(number, precision, thousandsSeparator) {
  let result;

  if (!number) {
    return "";
  }

  result = accounting.formatNumber(number, precision, thousandsSeparator);

  return result;
}
